export default {
  BEFORE: 'before',
  AFTER: 'after',
};
